import { render, staticRenderFns } from "./PageInvoiceCommission.vue?vue&type=template&id=e10df754&scoped=true"
import script from "./PageInvoiceCommission.vue?vue&type=script&lang=js"
export * from "./PageInvoiceCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10df754",
  null
  
)

export default component.exports